import { useQuery, UseQueryOptions } from "@tanstack/react-query";

import {
  ActiveSubscriptionResponse,
  SubscriptionsDataQuotaResponse
} from "@/types/subscriptions";

import {
  getActiveSubscription,
  getSubscriptionsDataQuota
} from "./subscriptionsApi";

export const useSubscription = (
  options?: Omit<
    UseQueryOptions<
      SubscriptionsDataQuotaResponse,
      Error,
      SubscriptionsDataQuotaResponse
    >,
    "queryKey" | "queryFn"
  >
) => {
  return useQuery({
    queryKey: ["subscriptions"],
    queryFn: getSubscriptionsDataQuota,
    ...options
  });
};

export const useActiveSubscription = (
  options?: Omit<
    UseQueryOptions<
      ActiveSubscriptionResponse,
      Error,
      ActiveSubscriptionResponse
    >,
    "queryKey" | "queryFn"
  >
) => {
  return useQuery({
    queryKey: ["active-subscription"],
    queryFn: getActiveSubscription,
    ...options
  });
};
